import api from './axios';

const templatesApi = {
  listTemplates: async (companyId, options = {}) => {
    const response = await api.get('/templates', {
      params: {
        companyId,
        includePublic: options.includePublic !== false,
        ownedOnly: options.ownedOnly === true
      }
    });
    return response.data.templates || [];
  },

  saveFromProject: async (projectId, templateData) => {
    const response = await api.post(`/templates/from-project/${projectId}`, templateData);
    return response.data.template;
  },

  applyToProject: async (templateId, projectId) => {
    const response = await api.post(`/templates/${templateId}/apply-to-project/${projectId}`);
    return response.data;
  },

  updateTemplate: async (templateId, templateData) => {
    const response = await api.put(`/templates/${templateId}`, templateData);
    return response.data.template;
  },

  deleteTemplate: async (templateId) => {
    const response = await api.delete(`/templates/${templateId}`);
    return response.data;
  }
};

export default templatesApi;
